import React from 'react'

import cn from 'classnames'

import ChainToken from '@src/components/ChainToken'
import SandDollarIcon from '@src/components/icons/SandDollar'
import { getChainNameFromChainId } from '@src/configs/chainInfo'
import { IToken } from '@src/types/token'
import { isFeatureEnabled } from '@src/utils'
import { formatNumber } from '@src/utils/formatFee'

interface CompactTokensListItemProps {
    selectedToken?: IToken
    token: IToken
    onTokenClicked: (token: IToken) => void
    userBalanceInTokens?: string
    userBalanceInUsd?: string
    isCurrentlySelected?: boolean
}

export const CompactTokensListItem: React.FC<CompactTokensListItemProps> = ({
    selectedToken,
    token,
    onTokenClicked,
    userBalanceInTokens,
    userBalanceInUsd,
    isCurrentlySelected = false,
}) => {
    const isSelected = token.address === selectedToken?.address && token.chainId === selectedToken?.chainId

    return (
        <button
            className={cn(
                'flex w-full items-center gap-3 rounded-md p-2 transition-colors duration-200',
                !isCurrentlySelected && !isSelected && 'hover:bg-token-modal-chain-hover',
                isSelected && 'bg-token-modal-chain-hover',
                isCurrentlySelected && 'bg-mach-gray'
            )}
            onClick={() => onTokenClicked(token)}
        >
            <ChainToken
                tokenLogo={token.name === 'BitTorrent' ? '/assets/token/btt.png' : token.logoURI}
                networkIcon={`/assets/network/${getChainNameFromChainId(token.chainId)}.png`}
                tokenIconSize={28}
                chainIconSize={14}
                isTokenSelector={true}
            />
            <div className='flex flex-1 flex-col items-start overflow-hidden'>
                <div className='flex items-center gap-1'>
                    <span className='text-left text-[14px] !leading-5'>{token.name}</span>
                    {!token.isStableCoin && isFeatureEnabled('SAND_DOLLARS') && (
                        <SandDollarIcon height='16' width='16' />
                    )}
                </div>
                <span className='overflow-hidden text-ellipsis text-left text-[10px] text-token-modal-label-text'>
                    {token.symbol}
                </span>
            </div>
            <div className='flex items-center gap-2'>
                {userBalanceInTokens && (
                    <div className='flex flex-col items-end'>
                        <span className='text-[14px] font-medium'>{userBalanceInTokens?.split(' ')?.[0]}</span>
                        {userBalanceInUsd && (
                            <span className='text-xs text-token-modal-label-text'>
                                {userBalanceInUsd.startsWith('<')
                                    ? formatNumber(userBalanceInUsd, 4)
                                    : `$${formatNumber(userBalanceInUsd, 4)}`}
                            </span>
                        )}
                    </div>
                )}
                {isCurrentlySelected && <div className='h-2 w-2 shrink-0 rounded-full bg-white' />}
                {isSelected && !isCurrentlySelected && (
                    <div className='h-2 w-2 shrink-0 rounded-full bg-token-modal-accent-blue' />
                )}
            </div>
        </button>
    )
}

export default CompactTokensListItem
